module.exports = "<input type=\"radio\" [attr.name]=\"name\" [attr.value]=\"instanceValue\" [attr.checked]=\"isChecked\" [attr.disabled]=\"disabled\">\n<span class=\"option-box\" [class.disabled]=\"disabled\" tabindex=\"0\" #optionbox>\n    <span class=\"inner-circle\" [class.active]=\"isChecked\"></span>\n    <div class=\"inner-circle ripple-circle\" [class.visible]=\"isClicking\"></div>\n</span>\n<label class=\"viega-radio-button-label\" [class.disabled]=\"disabled\">\n    <ng-content></ng-content>\n</label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-radio-button/viega-radio-button.component.html
// module id = lejJ
// module chunks = 5